















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from '../../components/Loading.vue';
import storage from '../../utils/storage';
import moment from 'moment';
import tableModel from '../../components/table/tableModel.vue';
import ModalBox from '../../components/PmModalBox.vue';
@Component({
  components: {
    Loading,
    tableModel,
  },
})
export default class CheckOrder extends Vue {
  private user: any;
  private checkedList: any = []; // 已选择的选项
  private plainOptions = []; // 一共有多少选项
  private spinning = false;
  private dataJson: any = {};
  private tableDataJson: any = [];
  private orderID: string = '';
  private changeJson: any = {
    orderID: '',
    selectGift: '0',
    checkedList: [],
    rate: 5,
    rateLink: '',
    email: '',
    csEmail: '',
    note: '',
    date: null,
  };
  // private moneyArr: any = [10, 15, 20, 30, 'product', 'refund'];
  private result: boolean = false;
  private columns: any = [{
    title: 'OrderID',
    dataIndex: 'orderID',
    width: '7%',
    scopedSlots: { customRender: 'orderID' },
  }, {
    title: 'productName',
    dataIndex: 'productName',
    width: '10%',
    scopedSlots: { customRender: 'productName' },
  }, {
    title: 'Brand',
    dataIndex: 'brand',
    width: '5%',
    scopedSlots: { customRender: 'brand' },
  }, {
    title: 'Asin',
    dataIndex: 'asin',
    width: '7%',
    scopedSlots: { customRender: 'asin' },
  }, {
    title: 'Price',
    dataIndex: 'price',
    width: '5%',
    scopedSlots: { customRender: 'price' },
  }, {
    title: 'Tax',
    dataIndex: 'itemTax',
    width: '4%',
    scopedSlots: { customRender: 'itemTax' },
  }, {
    title: 'Address',
    dataIndex: 'shipAddress1',
    width: '10%',
    scopedSlots: { customRender: 'shipAddress1' },
  }, {
    title: 'City',
    dataIndex: 'shipCity',
    width: '3%',
    scopedSlots: { customRender: 'shipCity' },
  }, {
    title: 'Postal',
    dataIndex: 'shipPostalCode',
    width: '5%',
    scopedSlots: { customRender: 'shipPostalCode' },
  }, {
    title: 'State',
    dataIndex: 'shipState',
    width: '3%',
    scopedSlots: { customRender: 'shipState' },
  }, {
    title: 'Country',
    dataIndex: 'shipCountry',
    width: '6%',
    scopedSlots: { customRender: 'shipCountry' },
  }, {
    title: 'Gift',
    dataIndex: 'selectGift',
    width: '7%',
    scopedSlots: { customRender: 'selectGift' },
  }, {
    title: 'Email',
    dataIndex: 'email',
    width: '5%',
    scopedSlots: { customRender: 'email' },
  }, {
    title: 'PaymentsDate',
    dataIndex: 'paymentsDate',
    width: '8%',
    scopedSlots: { customRender: 'paymentsDate' },
  }, {
    title: 'RecipientName',
    dataIndex: 'recipientName',
    width: '7%',
    scopedSlots: { customRender: 'recipientName' },
  }, {
    title: 'shippingPrice',
    dataIndex: 'shippingPrice',
    width: '7%',
    scopedSlots: { customRender: 'shippingPrice' },
  }, {
    title: 'upTime',
    dataIndex: 'updateTime',
    width: '12%',
    scopedSlots: { customRender: 'updateTime' },
  }, {
    title: 'shippingTax',
    dataIndex: 'shippingTax',
    width: '7%',
    scopedSlots: { customRender: 'shippingTax' },
  }];
  private giftTypeArr: any = [];
  @Watch('orderID')
  private getOrderID(newVal: string, oldVal: string) {
    if (this.dataJson.length) {
      this.dataJson.splice(0, this.dataJson.length);
    }
    this.result = false;
  }
  private mounted() {
    this.getGiftType();
  }
  private confirmData() {
    const that = this;
    this.$confirm({
      title: 'Change Data',
      content: `OrderID:${this.orderID}   Gift: $${this.changeJson.selectGift} Email: ${ this.changeJson.email }`,
      onOk() {
        that.editData();
      },
    });
  }
  private getGiftType() {
    const that = this;
    this.spinning = true;
    const url: string = '/api/getGiftType';
    const args = {
      team: 'gsk',
    };
    this.axios.post(url, args).then((res) => {
      that.spinning = false;
      const data = res.data.data;
      that.giftTypeArr = data.gift;
      that.plainOptions = data.other;
      // that.$message.info('Data change !!!');
    });
  }
  private judgeArgs(argsJson: any) {
    if (argsJson.orderID === '' || argsJson.email === '' || argsJson.csEmail === '') {
      this.$message.warning('Please check  orderID || CustomerEmail || csEmail');
      return false;
    }
    if ((argsJson.selectGift === '0' && argsJson.checkedList.length === 0 )) {
      this.$message.warning('Gift OR Checkbox, You have to choose between the two');
      return false;
    }
    return true;
  }
  private async editData() {
    const that = this;
    const argsJson = this.changeJson;
    argsJson.orderID = this.orderID.trim();
    // 判断 必填项
    const argFlag = this.judgeArgs(argsJson);
    if (!argFlag) {
      return false;
    }
    const flag = true;
    // 不能重新调用 api, 会更改 changeJson
    // const flag = await this.getData();


    this.result = false;
    if (flag) {
      this.spinning = true;
      const url: string = '/api/checkOrderDetails';
      argsJson.date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      // 此处 args 要成为一个对象
      const args = argsJson;
      this.axios.post(url, args).then((res) => {
        that.spinning = false;
        that.$message.info('Data change !!!');
      });
    }
  }
  private async getData() {
    return new Promise((resolve, reject) => {
      const that = this;
      this.spinning = true;
      const url: string = '/api/getOrderDetails';
      const args = {
        orderID: this.orderID.trim(),
      };
      this.axios.post(url, args).then((res) => {
        if (res && res.data.code === 10) {
          that.$message.warning(res.data.msg);
          that.spinning = false;
          resolve(false);
        } else if (res === undefined) {
          that.spinning = false;
        } else {
          that.tableDataJson = res.data.data;
          const data = res.data.data[0];
          that.dataJson = data;
          that.pushChangeJson(data);
          that.spinning = false;
          if (data) {
            that.result = true;
            resolve(true);
          }
        }
        resolve('');
      }).catch((err) => {
        reject(false);
      });
    });
  }
  private pushChangeJson(data: any) {
    console.log(data);
    let selectGift = '0';
    let rate = 0;
    const checkedList: any = [];
    if (data.selectGift) {
      const sData = data.selectGift.split('|');
      sData.forEach((value: string, index: number) => {
        if (index === 0) {
          selectGift = value;
        } else {
          checkedList.push(value);
        }
      });
    }
    if (data.rate) {
      rate = data.rate;
    } else {
      rate = 0;
    }
    const dataJson = {
      selectGift,
      checkedList,
      rate,
      rateLink: data.rateLink,
      email: data.email,
      csEmail: data.csEmail,
      note: data.note,
      date: null,
    };
    Object.assign(this.changeJson, dataJson);
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  private emitEmpty() {
    const inputBox: HTMLInputElement = this.$refs.orderIDInput as HTMLInputElement;
    inputBox.focus();
    this.orderID = '';
  }
  private emitEmpty2(type: string) {
    if (type === 'EmailInput') {
      const inputBox: HTMLInputElement = this.$refs.EmailInput as HTMLInputElement;
      inputBox.focus();
      this.changeJson.email = '';
    } else if (type === 'csEmailInput') {
      const inputBox2: HTMLInputElement = this.$refs.csEmailInput as HTMLInputElement;
      inputBox2.focus();
      this.changeJson.csEmail = '';
    }

  }
}
